import * as angular from "angular";
import template from "./entity-classifications.html";
import "./entity-classifications.less";
import { FORM_ENTITY_CLASSIFICATIONS } from "../../../../../../routes";
import { globs } from "../../../../../../services/globs";
import viewModesSection from "../../../../../view-modes-section";
import entityClassificationsViewer from "./entity-classifications-viewer/entity-classifications-viewer";
import entityClassificationsEditor from "./entity-classifications-editor/entity-classifications-editor";

export function controller(appState, loadingService, api, securityService) {
	const ctrl = this;
	let classificationActions;

	ctrl.loadClassifications = loadClassifications;

	ctrl.$onInit = () => {
		ctrl.isLoading = false;
		ctrl.loadError = false;
		ctrl.classifications = [];
		classificationActions = globs.entityTypes
			.byType(ctrl.typeConfig.Code)
			.classifications;
		const canViewPattern = classificationActions.byCode("*").read;
		ctrl.canViewClassifications = securityService.isActionOrPatternAllowed(canViewPattern);

		if(ctrl.entity.Id && ctrl.canViewClassifications) {
			loadClassifications().catch(() => undefined);
		}
	};

	function loadClassifications() {
		const route = FORM_ENTITY_CLASSIFICATIONS(appState.forms.selected.Id, ctrl.entity.Id);

		ctrl.isLoading = true;
		const promise = api.get(route)
			.then(classifications => {
				ctrl.classifications = classifications
					.filter(classification => securityService.isActionAllowed(
						classificationActions.byCode(classification.Code).read
					))
					.map(classification => ({
						...classification,
						isPrimary: classification.Id === ctrl.entity.Classification?.Id
					}));

				ctrl.classifications = sortClassifications(ctrl.classifications);
				ctrl.loadError = false;
				return ctrl.classifications;
			})
			.catch(error => {
				ctrl.loadError = true;
				throw error;
			})
			.finally(() => {
				ctrl.isLoading = false;
			});

		return loadingService.watch(promise);
	}

	function sortClassifications(classifications) {
		return [...classifications].sort((left, right) => {
			if(!!left.isPrimary !== !!right.isPrimary) {
				return left.isPrimary ? -1 : 1;
			}

			return left.Code.localeCompare(right.Code);
		});
	}
}

export default angular.module("vesl.components.entity-classifications", [
	viewModesSection,
	entityClassificationsViewer,
	entityClassificationsEditor
])
	.component("entityClassifications", {
		controller,
		template,
		bindings: {
			entity: "<",
			typeConfig: "<",
			post: "=",
			initialMode: "<"
		}
	})
	.name;
